module.exports = __webpack_public_path__ + "static/media/question3.31a965b6.gif";